"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AudienceViewToggle;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _data = require("../../actions/data");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function AudienceViewToggle() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var audienceView = (0, _reactRedux.useSelector)(function (state) {
    return state.audienceView.view.value;
  });
  var options = (0, _reactRedux.useSelector)(function (state) {
    return state.audienceView.options;
  });

  var audienceViewToggle = function audienceViewToggle(selection) {
    var value = options.find(function (option) {
      return option.value === selection.value;
    });
    dispatch((0, _data.setAudienceView)(value));
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, options.length > 1 && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown, {
    className: "audience-view-toggle--select",
    value: audienceView,
    options: options,
    direction: "left",
    onChange: function onChange(event, data) {
      audienceViewToggle(data);
    }
  }));
}